module.exports = __webpack_public_path__ + "static/media/selcare.d535c97e.png";